import { Nullable } from '@/utils/types';

export function convertFromVCF (vcf: string, callback: (err: Nullable<string>, data: any) => void) {
  const worker = new Worker(new URL('./vcard-parser-worker.js', import.meta.url), { type: 'module' });
  worker.postMessage(vcf);

  worker.onmessage = (e) => {
    callback(null, e.data);
  }

  worker.onerror = (e) => {
    callback(e.message, null);
  }
}
